<template>
  <div class="mobile-student-layout">
    <div class="mobile-content" :class="{ 'no-tabbar': hideTabbar }">
      <router-view />
    </div>

    <van-tabbar v-if="!hideTabbar" route safe-area-inset-bottom>
      <van-tabbar-item replace to="/m/student/home" icon="home-o">
        首页
      </van-tabbar-item>
      <van-tabbar-item replace to="/m/student/practice" icon="edit">
        练习
      </van-tabbar-item>
      <van-tabbar-item replace to="/m/student/exam" icon="records">
        考试
      </van-tabbar-item>
      <van-tabbar-item replace to="/m/student/wrong" icon="warning-o">
        错题
      </van-tabbar-item>
      <van-tabbar-item replace to="/m/student/me" icon="user-o">
        我的
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'MobileStudentLayout',

  computed: {
    hideTabbar() {
      return this.$route.meta && this.$route.meta.hideTabbar
    }
  }
}
</script>

<style scoped>
.mobile-student-layout {
  min-height: 100vh;
  background: #f5f7fa;
}

.mobile-content {
  min-height: 100vh;
  padding-bottom: 56px;
  box-sizing: border-box;
}

.mobile-content.no-tabbar {
  padding-bottom: 0;
}
</style>